// extracted by mini-css-extract-plugin
export default {"spinner":"PushSpinner_spinner__w7fGH","spin":"PushSpinner_spin__7FTmp"};